<template>
  <div id="new-record-modal" class="modal fade" :class="{'is-open': open}" v-if="form">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 class="modal-title">編輯日誌紀錄</h3>
          <div class="col-3 text-right">
                <a class="btn btn-default m-0" 
                :class="{ disabled: record.ISDONE !== 'N' }"
                @click="$emit('delete')"
                >刪除事件</a>
          </div>
        </div>
        <div class="modal-body" :class="{'section-loading': allLoading}">
          <form class="form px-4">
            <h4 class="with-date-picker text-green d-inline-block">
              日期
              <div class="form-group ml-1 d-inline-block">
                <div class="d-inline-block">
                  <input type="text" class="form-control" v-model="form.date" disabled>
                </div>
                <span class="waring-block d-inline-block ml-2" v-if="recordInfo.ISMISS == 'Y'">
                  <span class="text"><span class="text-red">＊</span>未遇客戶</span>
                </span>
              </div>
            </h4>
            <div class="form-group">
              <h4 class="text-green">私人筆記</h4>
              <textarea class="form-control" cols="30" rows="3" v-model="form.note" placeholder="您尚未填寫私人筆記" maxlength="1000" @input="checkNote" @blur="checkNote"></textarea>
            </div>
            <div class="form-group">
              <h4 class="text-green">活動日誌</h4>
              <textarea class="form-control" cols="30" rows="3" v-model="form.title" @copy="onCopy($event)" placeholder="您尚未填寫拜訪紀錄" maxlength="1000" @input="checkTitle" @blur="checkTitle"></textarea>
            </div>
            <hr>
            <h4 class="text-green">
              <div class="dropdown float-right" v-if="recordInfo.ISMISS == 'N'"> 
                <a role="button" id="visit-common-dropdown" class="btn btn-default btn-sm m-0 text-orange"
                @click.stop.prevent="showDropdown('visit', $event)" :disabled="selectOpt.length > 4">
                  常用標籤
                </a>
                <div class="dropdown-menu common-tag" aria-labelledby="visit-common-dropdown">
                  <div class="row">
                    <div class="col-12"
                    v-if="isCommonTagEdit && currentDropdown=='visit'">
                      <div class="my-2"
                      v-for="(tag, i) in commonTag"
                      :key="`common-visit-edit-${i}`">
                        <input type="text" v-model="tag.name" class="form-control h-43" maxlength="6" @input="checkTagName(i)" @blur="checkTagName(i)" />
                      </div>
                    </div>
                    <div class="col-12"
                    v-else>
                      <a class="btn btn-border-green my-2 btn-block"
                      v-for="(tag, i) in commonTag"
                      :key="`common-visit-${i}`"
                      :class="hasCommonItem(tag.name) ? 'is-press' : ''"
                      @click="toggleCommonSelect(tag)">
                        <span v-if="tag.name && tag.name.trim() != ''">{{ tag.name }}</span>
                        <span v-else style="color:white">.</span>
                      </a>
                    </div>
                  </div>
                  <div class="row-cus">
                    <div>
                      <button 
                      v-if="!isCommonTagEdit"
                      @click.stop.prevent="isCommonTagEdit = !isCommonTagEdit" class="btn btn-icon btn-default btn-sm m-0">
                        <i class="icon-edit"></i>
                      </button>
                      <button
                      v-else 
                      @click.stop.prevent="updateCustomItem" class="btn btn-primary btn-0">
                        儲存
                      </button> 
                    </div>
                    <!-- <div class="col-7 text-right">
                      <a class="btn btn-primary btn-sm m-0"
                      @click.stop.prevent="insertCommonTag()"
                      :disabled="!selectedCommonTag.length">
                        代入標籤
                        <span v-if="currentDropdown=='visit' && selectedCommonTag.length">
                          {{selectedCommonTag.length}}/{{5 - selectOpt.length}}
                        </span>
                      </a>
                    </div> -->
                  </div>
                </div>
              </div>
              增員拜訪
            </h4>
            <div class="btn-grids">
              <div class="btn btn-border-green"
              v-for="(btn, idx) in visitOpt"
              :key="`visit-item-${idx}`"
              :disabled="recordInfo.ISMISS == 'Y'"
              :class="{
                'disabled': recordInfo.ISMISS == 'Y',
                'is-edit': !btn.edit===false,
                'is-press': btn.common == true,
              }">

                <!-- 常用帶入的標籤 & 按加加增加的標籤 -->
                <form @submit.stop.prevent="commitTag('visit', btn)" v-if="!btn.edit===false">
                  <input type="text" class="form-control" v-model="btn.name" />
                  <a class="close AAA"
                  @click="removeItem('visitOpt', idx, btn)">
                    <i class="icon-close"></i>
                  </a>
                </form>


                <!-- 固定的標籤 -->
                <div role="button"
                v-else
                @click="toggleSelect('visit', btn, idx)">
                  {{btn.name}}
                </div>

                <!-- 如果不是固定標籤的小叉叉 -->
                <a v-if="!btn.default" class="close BBB"
                @click="removeItem('visitOpt', idx, btn)">
                  <i class="icon-close"></i>
                </a>

              </div>

              <!-- 加號小框 常用版-->
              <a role="button" class="btn btn-border-green add-new"
              v-if="selectOpt.length < 5 && recordInfo.ISMISS == 'N'"
              @click.stop.prevent="showDropdown('visit', '#visit-common-dropdown')">
                <div role="button" class="ele-center">
                  <i class="icon-add_new"></i>
                </div>
              </a>
            </div>
            <hr>
            <h4 class="text-green">
              <div class="dropdown float-right" v-if="recordInfo.ISMISS == 'N'">
                <a role="button" id="relation-common-dropdown" class="btn btn-default btn-sm m-0 text-orange float-right"
                  @click.stop.prevent="showDropdown('relation', $event)" :disabled="selectOpt.length > 4">
                  常用標籤
                </a>
                <div class="dropdown-menu common-tag" aria-labelledby="relation-common-dropdown">
                  <div class="row">
                    <div class="col-12"
                    v-if="isCommonTagEdit && currentDropdown=='relation'">
                      <div class="my-2"
                      v-for="(tag, i) in commonTag"
                      :key="`common-relation-edit-${i}`">
                        <input type="text" v-model="tag.name" class="form-control" maxlength="6" @input="checkTagName(i)" @blur="checkTagName(i)" />
                      </div>
                    </div>
                    <div class="col-12"
                    v-else>
                      <a class="btn btn-border-green my-2 btn-block"
                      v-for="(tag, i) in commonTag"
                      :key="`common-relation-${i}`"
                      :class="hasCommonItem(tag.name) ? 'is-press' : ''"
                      @click="toggleCommonSelect(tag)">
                        <span v-if="tag.name && tag.name.trim() != ''">{{ tag.name }}</span>
                        <span v-else style="color:white">.</span>
                      </a>
                    </div>
                  </div>
                  <div class="row-cus">
                    <div>
                      <button 
                      v-if="!isCommonTagEdit"
                      @click.stop.prevent="isCommonTagEdit = !isCommonTagEdit" class="btn btn-icon btn-default btn-sm m-0">
                        <i class="icon-edit"></i>
                      </button>
                      <button
                      v-else 
                      @click.stop.prevent="updateCustomItem" class="btn btn-primary btn-0">
                        儲存
                      </button>
                    </div>
                    <!-- <div class="col-7 text-right">
                      <a class="btn btn-primary btn-sm m-0"
                      @click.stop.prevent="insertCommonTag()"
                      :disabled="!selectedCommonTag.length">
                        代入標籤
                        <span v-if="currentDropdown=='relation' && selectedCommonTag.length">
                          {{selectedCommonTag.length}}/{{5 - selectOpt.length}}
                        </span>
                      </a>
                    </div> -->
                  </div>
                </div>
              </div>
              關係建立
            </h4>
            <div class="btn-grids">
              <div class="btn btn-border-green"
              role="button"
              v-for="(btn, idx) in relationOpt"
              :key="`relation-item-${idx}`"
              :class="{
                'disabled': recordInfo.ISMISS == 'Y',
                'is-edit': !btn.edit===false,
                'is-press': btn.common == true
              }">
                <form @submit.stop.prevent="commitTag('relationOpt', btn)" v-if="!btn.edit===false">
                  <input type="text" class="form-control" v-model="btn.name" />
                  <a v-if="!btn.default" class="close"
                  @click="removeItem('relationOpt', idx, btn)">
                    <i class="icon-close"></i>
                  </a>
                </form>
                <div role="button"
                v-else
                @click="toggleSelect('relation', btn, idx)">
                  {{btn.name}}
                </div>
                <a v-if="!btn.default" class="close"
                @click="removeItem('relationOpt', idx, btn)">
                  <i class="icon-close"></i>
                </a>
              </div>
              <!-- 加號小框 自訂版-->
              <!-- <a role="button" class="btn btn-border-green add-new"
              v-if="selectOpt.length < 5 && recordInfo.ISMISS == 'N'"
              @click="addItem('relationOpt')">
                <div role="button">
                  <i class="icon-add_new"></i>
                </div>
              </a> -->
              <!-- 加號小框 常用版-->
              <a role="button" class="btn btn-border-green add-new"
              v-if="selectOpt.length < 5 && recordInfo.ISMISS == 'N'"
              @click.stop.prevent="showDropdown('relation', '#relation-common-dropdown')">
                <div role="button" class="ele-center">
                  <i class="icon-add_new"></i>
                </div>
              </a>
            </div>
            <hr>
            <h4 class="text-green">
              <div class="dropdown float-right" v-if="recordInfo.ISMISS == 'N'">
                <a role="button" id="analize-common-dropdown" class="btn btn-default btn-sm m-0 text-orange float-right"
                  @click.stop.prevent="showDropdown('analize', $event)" :disabled="selectOpt.length > 4">
                  常用標籤
                </a>
                <div class="dropdown-menu common-tag" aria-labelledby="analize-common-dropdown">
                  <div class="row">
                    <div class="col-12"
                    v-if="isCommonTagEdit && currentDropdown=='analize'">
                      <div class="my-2"
                      v-for="(tag, i) in commonTag"
                      :key="`common-analize-edit-${i}`">
                        <input type="text" v-model="tag.name" class="form-control" maxlength="6" @input="checkTagName(i)" @blur="checkTagName(i)" />
                      </div>
                    </div>
                    <div class="col-12"
                    v-else>
                      <a class="btn btn-border-green my-2 btn-block"
                      v-for="(tag, i) in commonTag"
                      :key="`common-analize-${i}`"
                      :class="hasCommonItem(tag.name) ? 'is-press' : ''"
                      @click="toggleCommonSelect(tag)">
                        <span v-if="tag.name && tag.name.trim() != ''">{{ tag.name }}</span>
                        <span v-else style="color:white">.</span>
                      </a>
                    </div>
                  </div>
                  <div class="row-cus">
                    <div>
                      <button 
                      v-if="!isCommonTagEdit"
                      @click.stop.prevent="isCommonTagEdit = !isCommonTagEdit" class="btn btn-icon btn-default btn-sm m-0">
                        <i class="icon-edit"></i>
                      </button>
                      <button
                      v-else 
                      @click.stop.prevent="updateCustomItem" class="btn btn-primary btn-0">
                        儲存
                      </button>
                    </div>
                    <!-- <div class="col-7 text-right">
                      <a class="btn btn-primary btn-sm m-0"
                      @click.stop.prevent="insertCommonTag()"
                      :disabled="!selectedCommonTag.length">
                        代入標籤
                        <span v-if="currentDropdown=='analize' && selectedCommonTag.length">
                          {{selectedCommonTag.length}}/{{5 - selectOpt.length}}
                        </span>
                      </a>
                    </div> -->
                  </div>
                </div>
              </div>
              需求分析
            </h4>
            <div class="btn-grids">
              <div class="btn btn-border-green"
              role="button"
              v-for="(btn, idx) in analizeOpt"
              :key="`analize-item-${idx}`"
              :class="{
                'disabled': recordInfo.ISMISS == 'Y',
                'is-edit': !btn.edit===false,
                'is-press': btn.common == true
              }">
                <form @submit.stop.prevent="commitTag('analizeOpt', btn)" v-if="!btn.edit===false">
                  <input type="text" class="form-control" v-model="btn.name" />
                  <a v-if="!btn.default" class="close"
                  @click="removeItem('analizeOpt', idx, btn)">
                    <i class="icon-close"></i>
                  </a>
                </form>
                <div role="button"
                v-else
                @click="toggleSelect('analize', btn, idx)">
                  {{btn.name}}
                </div>
                <a v-if="!btn.default" class="close"
                @click="removeItem('analizeOpt', idx, btn)">
                  <i class="icon-close"></i>
                </a>
              </div>
              <!-- 加號小框 自訂版-->
              <!-- <a role="button" class="btn btn-border-green add-new"
              v-if="selectOpt.length < 5 && recordInfo.ISMISS == 'N'"
              @click="addItem('analizeOpt')">
                <div role="button">
                  <i class="icon-add_new"></i>
                </div>
              </a> -->

              <!-- 加號小框 常用版-->
              <a role="button" class="btn btn-border-green add-new"
              v-if="selectOpt.length < 5 && recordInfo.ISMISS == 'N'"
              @click.stop.prevent="showDropdown('analize', '#analize-common-dropdown')">
                <div role="button" class="ele-center">
                  <i class="icon-add_new"></i>
                </div>
              </a>
            </div>
            <hr>
            <h4 class="text-green">
              <div class="dropdown float-right" v-if="recordInfo.ISMISS == 'N'">
                <a role="button" id="recommand-common-dropdown" class="btn btn-default btn-sm m-0 text-orange float-right"
                  @click.stop.prevent="showDropdown('recommand', $event)" :disabled="selectOpt.length > 4">
                  常用標籤
                </a>
                <div class="dropdown-menu common-tag" aria-labelledby="recommand-common-dropdown">
                  <div class="row">
                    <div class="col-12"
                    v-if="isCommonTagEdit && currentDropdown=='recommand'">
                      <div class="my-2"
                      v-for="(tag, i) in commonTag"
                      :key="`common-recommand-edit-${i}`">
                        <input type="text" v-model="tag.name" class="form-control" maxlength="6" @input="checkTagName(i)" @blur="checkTagName(i)" />
                      </div>
                    </div>
                    <div class="col-12"
                    v-else>
                      <a class="btn btn-border-green my-2 btn-block"
                      v-for="(tag, i) in commonTag"
                      :key="`common-recommand-${i}`"
                      :class="hasCommonItem(tag.name) ? 'is-press' : ''"
                      @click="toggleCommonSelect(tag)">
                        <span v-if="tag.name && tag.name.trim() != ''">{{ tag.name }}</span>
                        <span v-else style="color:white">.</span>
                      </a>
                    </div>
                  </div>
                  <div class="row-cus">
                    <div>
                      <button 
                      v-if="!isCommonTagEdit"
                      @click.stop.prevent="isCommonTagEdit = !isCommonTagEdit" class="btn btn-icon btn-default btn-sm m-0">
                        <i class="icon-edit"></i>
                      </button>
                      <button
                      v-else 
                      @click.stop.prevent="updateCustomItem" class="btn btn-primary btn-0">
                        儲存
                      </button>
                    </div>
                    <!-- <div class="col-7 text-right">
                      <a class="btn btn-primary btn-sm m-0"
                      @click.stop.prevent="insertCommonTag()"
                      :disabled="!selectedCommonTag.length">
                        代入標籤
                        <span v-if="currentDropdown=='recommand' && selectedCommonTag.length">
                          {{selectedCommonTag.length}}/{{5 - selectOpt.length}}
                        </span>
                      </a>
                    </div> -->
                  </div>
                </div>
              </div>
              建議書/促約
            </h4>
            <div class="btn-grids">
              <div class="btn btn-border-green"
              role="button"
              v-for="(btn, idx) in recommandOpt"
              :key="`recommand-item-${idx}`"
              :class="{
                'disabled': recordInfo.ISMISS == 'Y',
                'is-edit': !btn.edit===false,
                'is-press': btn.common == true
              }">
                <form @submit.stop.prevent="commitTag('recommandOpt', btn)" v-if="!btn.edit===false">
                  <input type="text" class="form-control" v-model="btn.name" />
                  <a v-if="!btn.default" class="close"
                  @click="removeItem('recommandOpt', idx, btn)">
                    <i class="icon-close"></i>
                  </a>
                </form>
                <div role="button"
                v-else
                @click="toggleSelect('recommand', btn, idx)">
                  {{btn.name}}
                </div>
                <a v-if="!btn.default" class="close"
                @click="removeItem('recommandOpt', idx, btn)">
                  <i class="icon-close"></i>
                </a>
              </div>
              <!-- 加號小框 自訂版-->
              <!-- <a role="button" class="btn btn-border-green add-new"
              v-if="selectOpt.length < 5 && recordInfo.ISMISS == 'N'"
              @click="addItem('recommandOpt')">
                <div role="button">
                  <i class="icon-add_new"></i>
                </div>
              </a> -->

              <!-- 加號小框 常用版-->
              <a role="button" class="btn btn-border-green add-new"
              v-if="selectOpt.length < 5 && recordInfo.ISMISS == 'N'"
              @click.stop.prevent="showDropdown('recommand', '#recommand-common-dropdown')">
                <div role="button" class="ele-center">
                  <i class="icon-add_new"></i>
                </div>
              </a>
            </div>
            <hr>
            <h4 class="text-green">
              <div class="dropdown float-right" v-if="recordInfo.ISMISS == 'N'">
                <a role="button" id="service-common-dropdown" class="btn btn-default btn-sm m-0 text-orange float-right"
                  @click.stop.prevent="showDropdown('service', $event)" :disabled="selectOpt.length > 4">
                  常用標籤
                </a>
                <div class="dropdown-menu common-tag" aria-labelledby="service-common-dropdown">
                  <div class="row">
                    <div class="col-12"
                    v-if="isCommonTagEdit && currentDropdown=='service'">
                      <div class="my-2"
                      v-for="(tag, i) in commonTag"
                      :key="`common-service-edit-${i}`">
                        <input type="text" v-model="tag.name" class="form-control" maxlength="6" @input="checkTagName(i)" @blur="checkTagName(i)" />
                      </div>
                    </div>
                    <div class="col-12"
                    v-else>
                      <a class="btn btn-border-green my-2 btn-block"
                      v-for="(tag, i) in commonTag"
                      :key="`common-service-${i}`"
                      :class="hasCommonItem(tag.name) ? 'is-press' : ''"
                      @click="toggleCommonSelect(tag)">
                        <span v-if="tag.name && tag.name.trim() != ''">{{ tag.name }}</span>
                        <span v-else style="color:white">.</span>
                      </a>
                    </div>
                  </div>
                  <div class="row-cus">
                    <div>
                      <button 
                      v-if="!isCommonTagEdit"
                      @click.stop.prevent="isCommonTagEdit = !isCommonTagEdit" class="btn btn-icon btn-default btn-sm m-0">
                        <i class="icon-edit"></i>
                      </button>
                      <button
                      v-else 
                      @click.stop.prevent="updateCustomItem" class="btn btn-primary btn-0">
                        儲存
                      </button>
                    </div>
                    <!-- <div class="col-7 text-right">
                      <a class="btn btn-primary btn-sm m-0"
                      @click.stop.prevent="insertCommonTag()"
                      :disabled="!selectedCommonTag.length">
                        代入標籤
                        <span v-if="currentDropdown=='service' && selectedCommonTag.length">
                          {{selectedCommonTag.length}}/{{5 - selectOpt.length}}
                        </span>
                      </a>
                    </div> -->
                  </div>
                </div>
              </div>
              客戶服務
            </h4>
            <div class="btn-grids">
              <div class="btn btn-border-green"
              role="button"
              v-for="(btn, idx) in serviceOpt"
              :key="`service-item-${idx}`"
              :class="{
                'disabled': recordInfo.ISMISS == 'Y',
                'is-edit': !btn.edit===false,
                'is-press': btn.common == true
              }">
                <form @submit.stop.prevent="commitTag('serviceOpt', btn)" v-if="!btn.edit===false">
                  <input type="text" class="form-control" v-model="btn.name" />
                  <a v-if="!btn.default" class="close"
                  @click="removeItem('serviceOpt', idx, btn)">
                    <i class="icon-close"></i>
                  </a>
                </form>
                <div role="button"
                v-else
                @click="toggleSelect('service', btn, idx)">
                  {{btn.name}}
                </div>
                <a v-if="!btn.default" class="close"
                @click="removeItem('serviceOpt', idx, btn)">
                  <i class="icon-close"></i>
                </a>
              </div>
              <!-- 加號小框 自訂版-->
              <!-- <a role="button" class="btn btn-border-green add-new"
              v-if="selectOpt.length < 5 && recordInfo.ISMISS == 'N'"
              @click="addItem('serviceOpt')">
                <div role="button">
                  <i class="icon-add_new"></i>
                </div>
              </a> -->

              <!-- 加號小框 常用版-->
              <a role="button" class="btn btn-border-green add-new"
              v-if="selectOpt.length < 5 && recordInfo.ISMISS == 'N'"
              @click.stop.prevent="showDropdown('service', '#service-common-dropdown')">
                <div role="button" class="ele-center">
                  <i class="icon-add_new"></i>
                </div>
              </a>
            </div>
            <hr>
            <div class="actions text-right">
              <a role="button" @click="$emit('close')" class="btn btn-default">取消</a>
              <a role="button" @click="submit()" class="btn btn-primary">儲存</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import { getCustVisitItem, getCustDefaultItem, editCustItem } from '@/service'

export default {
  name: 'NewReocrdModal',
  components: { DatePicker},
  props: {
    record: {
      type: Object,
      default: () => {
        return null
      }
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    allLoading () {
      return this.defaultLoading || this.visitLoading
    }
  },
  data () {
    return {
      selectedCommonTag: [],
      currentDropdownCount: 0,
      defaultLoading: false,
      visitLoading: false,
      currentDropdown: '',
      dropdownItem: null,
      isCommonTagEdit: false,
      dropdownOpen: false,
      currentLast: 0,
      customeize: {
        visitOpt: 0,
        relationOpt: 0,
        analizeOpt: 0,
        recommandOpt: 0,
        serviceOpt: 0
      },
      selectOpt: [],
      selectedTag: {
        visit: [],
        relation: [],
        analize: [],
        recommand: [],
        service: []
      },
      removeCommonTag: [],
      commonTag: [
        {name: ''},
        {name: ''},
        {name: ''},
        {name: ''},
        {name: ''}
      ],
      visitOpt: [],
      relationOpt: [],
      analizeOpt: [],
      recommandOpt: [],
      serviceOpt: [],
      recordInfo:{
        EVENT_DATE:"",
        EVENT_SER_NO:"",
        EVENT_TIME:"",
        EVENT_YEAR:"",
        ISMISS:"Y",
        ISDONE:"N",
        NOTE_STRING:"",
        RECORD_STRING:"",
        RECORD_SYMBOL:"",
        REFERRAL1:"",
        REFERRAL2:"",
        SUB_CLS_CODE:"",
      },
      form: {
        data: '',
        note: '',
        title: '',
        visit: [],
        relation: [],
      },
      warningModalOpen: false,
      warningMessage: '',
      isDisabled: false
    }
  },
  watch: {
    // 更新 modal 資料
    open (val) {
      if (val) {
        if(this.form.note || this.form.title){
          this.isDisabled = true
        }
        this.syncRecord()
      }
    },
  },
  // computed: {
  //   isDisabled() {
  //     return this.form.note || this.form.title;
  //   }
  // },
  methods: {
    CloseWarningModal() {
      this.panelClose("warningModalOpen");
    },
    // handleDelete(){
    //   if (!this.isDisabled) {
    //     this.$emit('delete');
    //   }
    // },
    onCopy(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    //檢查私人筆記
    checkNote(){
      if (this.stringBytes(this.form.note, false, 1000) > 1000) {
        this.form.note = this.form.note.substring(0, this.stringBytes(this.form.note, true ,1000));
      }
    },
    //檢查活動日誌
    checkTitle(){
      if (this.stringBytes(this.form.title, false, 1000) > 1000) {
        this.form.title = this.form.title.substring(0, this.stringBytes(this.form.title, true ,1000));
      }
    },
    //檢查標籤
    checkTagName(i){
      if (this.stringBytes(this.commonTag[i].name, false, 12) > 12) {
        this.commonTag[i].name = this.commonTag[i].name.substring(0, this.stringBytes(this.commonTag[i].name, true ,12));
      }
    },
    syncRecord () {
      this.recordInfo = {...this.record} // 拷貝原始資料當參照
      this.init()
    },
    doGetCustVisitItem () {
      this.visitLoading = true
      getCustVisitItem(this.$store.state.userInfo.id).then(result => { //查詢拜訪紀錄自訂標籤
        if(result.header && result.header.status == '200'){
          const detailList = result.body.detail
          this.commonTag = [
            {name: detailList.cls_nm_1},
            {name: detailList.cls_nm_2},
            {name: detailList.cls_nm_3},
            {name: detailList.cls_nm_4},
            {name: detailList.cls_nm_5},
          ]
          console.log(this.commonTag);
          this.visitLoading = false
        }else{
          console.error('查詢拜訪紀錄自訂標籤 API 錯誤')
        }
        this.selectedCommonTag = []
        this.isCommonTagEdit = false
      })
    },
    doGetCustDefaultItem () {
      if(!this.record) return false
      this.defaultLoading = true
      getCustDefaultItem(this.$store.state.userInfo.id).then(result => {  //查詢拜訪紀錄固定標籤
        if(result.header && result.header.status == '200'){
          this.defaultLoading = false
          this.relationOpt = []
          this.analizeOpt = []
          this.recommandOpt = []
          this.serviceOpt = []
          this.visitOpt = []
          this.selectOpt = []
          // 將資料轉為陣列
          let recordDataAry = this.record.SUB_CLS_CODE.split(',').map(item => {
            return {
              code: item.substr(0, 5),
              name: item.slice(5),
            }
          })
          let modifyData = result.body.cls_item.map(item => {
            if(this.record.SUB_CLS_CODE.includes(item.cls_code)){  // active 編輯帶進來固定的標籤
              this.selectOpt.push({name:item.cls_nm, code:item.cls_code, default: true, common: true})
              return {name:item.cls_nm, code:item.cls_code, default: true, common: true}
            }else{
              return {name:item.cls_nm, code:item.cls_code, default: true}
            }
          })
          
          // 添加常用的標籤 
          const testCommon = /\w{3}9[5-9]/
          recordDataAry.forEach(item => {
            if(testCommon.test(item.code)){
              modifyData.push({...item, common: true})
              this.selectOpt.push({...item, common: true})
            }
          })

          // 添加自訂的標籤
          const testEdit = /\w{3}9[0-4]/
          recordDataAry.forEach(item => {
            if(testEdit.test(item.code)){
              modifyData.push({...item, edit: true})
              this.selectOpt.push({...item, edit: true})
            }
          })

          // 添加固定的標籤
          modifyData.forEach(item => {
            if(item.code.includes('A01')){  // 關係建立(A01)
              this.relationOpt.push(item)
            }else if(item.code.includes('A02')){  // 需求分析(A02)
              this.analizeOpt.push(item)
            }else if(item.code.includes('A03')){  // 建議書/促約(A03)
              this.recommandOpt.push(item)
            }else if(item.code.includes('A04')){  // 客戶服務(A04)
              this.serviceOpt.push(item)
            }else if(item.code.includes('A05')){  // 增員拜訪(A05)
              this.visitOpt.push(item)
            }
          })
          console.log(this.visitOpt)
        }else{
          console.error('查詢拜訪紀錄固定標籤 API 錯誤')
        }
      })
    },
    init () {
      this.form.note = this.recordInfo.NOTE_STRING == '您尚未填寫私人筆記' ? '' : this.recordInfo.NOTE_STRING //  同步私人筆記
      this.form.title = this.recordInfo.RECORD_STRING == '您尚未填寫活動日誌' ? '' : this.recordInfo.RECORD_STRING //  同步活動日誌
      this.form.date = this.recordInfo.EVENT_DATE  //  同步日期
      this.selectOpt = []  // 清空已選標籤
      this.customeize.visitOpt = 0
      this.customeize.relationOpt = 0
      this.customeize.analizeOpt = 0
      this.customeize.recommandOpt = 0
      this.customeize.serviceOpt = 0
      this.doGetCustVisitItem()  //查詢拜訪紀錄自訂標籤
      this.doGetCustDefaultItem()  //查詢拜訪紀錄固定標籤
    },
    updateCustomItem () {   // 編輯常用標籤
      let checkLimit = false
      this.commonTag.forEach(tag => {
        if(this.stringBytes(tag.name, false, 12) > 12){
          checkLimit = true
        }
      })
      if (checkLimit) {  // 驗證標籤長度
        return this.$toast.info({title: '常用標籤長度不得超過6個中文字'})
      }
      editCustItem(this.$store.state.userInfo.id, this.commonTag).then(result => {
        if(result.header && result.header.status == '200'){
          this.doGetCustVisitItem()
        }else{
          console.error('編輯常用標籤 API 錯誤')
        }
      })
    },
    insertCommonTag () {
      let opt = `${this.currentDropdown}Opt`

      this.selectedCommonTag.forEach(item => {
        if(item.trim().length > 0){
          let isDuplicated = false
          this[opt].forEach(optItem => {
             if( optItem.name == item ){
               isDuplicated = true
             }
          })
          if(!isDuplicated){
            this.selectedCommonTag.push(item)
            this[opt].push({name: item, common: true})
            this.selectOpt.push({name: item, common: true})
            this.selectedTag[this.currentDropdown].push(item)
            this.customeize[opt]++
          }
          
        }
      })
      this.dropdownClose()
    },
    showDropdown(type, evt) {
      if(this.selectOpt.length > 4) return false  // 如果超過5個已選標籤 就什麼都不做
      this.isCommonTagEdit = false
      this.dropdownClose()
      const $this = this
      this.removeCommonTag = []
      this.currentDropdown = type

      // this[`${type}Opt`].forEach((item) => {
      //   $this.commonTag.forEach(it => {
      //     if(it.name === item.name) {
      //       $this.selectedCommonTag.push(item.name)
      //     }
      //   })
      // })
      if(typeof evt == "string"){
        this.dropdownItem = document.querySelector(evt)
      }else{
        this.dropdownItem = evt.target
      }
      this.dropdownOpen = true
      // this.dropdownItem = evt.target
      this.currentLast = 3 - (this.customeize[`${type}Opt`] - $this.selectedCommonTag.length)
      this.dropdownItem.parentElement.classList.add('show')
      this.dropdownItem.nextSibling.classList.add('show')
    },
    commitTag (type, btn) {
      btn.edit = false  
      return false
    },
    hasCommonItem (tag) {
      return this.selectedCommonTag.indexOf(tag) > -1
    },
    toggleCommonSelect (btn) {
      let type = `${this.currentDropdown}Opt`
      let index = this.selectedCommonTag.indexOf(btn.name)
      if (index > -1) {
        let id = 0
        this.selectedCommonTag.splice(index, 1)
        this.currentDropdownCount--
        this.removeCommonTag.push(btn)
      } else if(this.selectedCommonTag.length < (5 - this.selectOpt.length)) {
          this.currentDropdownCount++
          this.selectedCommonTag.push(btn.name)
      }
      this.insertCommonTag()
    },
    toggleSelect (type, btn, idx) {    // 切換固定標籤
      if (this.recordInfo.ISMISS == 'Y') return false // 未遇客戶不執行
      let checkHasName = false
      let BtnIndex = 0
      this.selectOpt.forEach((item, index) => {  // 確認標籤是否有被選擇
        if(item.name == btn.name){
          checkHasName = true
          BtnIndex = index
        }
      })
      if(checkHasName){ // 如果有被選擇 
        this.selectOpt.splice(BtnIndex, 1)
        this[`${type}Opt`][idx].common = false // 切換 class
      }else{     // 如果有沒被選擇 
        if (this.selectOpt.length > 4) return false  // 已選標籤超過5 不執行
        this.selectOpt.push(btn)
        this[`${type}Opt`][idx].common = true  // 切換 class
      }
    },
    hasItem (attr, name) {
      if(!this.selectedTag[attr]) return false
      return this.selectedTag[attr].find(n => n == name);
    },
    removeItem (type, i, btn) {  // 移除自訂常用標籤
      this.customeize[type]--
      this[type].splice(i, 1)
      let removeInedx = -1
      this.selectOpt.forEach((item, index) => {
        if(btn.edit){  // get selectOpt edit tap index
          if(item.edit == true){
            removeInedx = index
          }
        }else{  // get selectOpt common tap index
          if(item.common == true && item.name == btn.name){
            removeInedx = index
          }
        }
      })
      if(removeInedx != -1){  // selectOpt 裡有編輯的標籤 移除該物件
        this.selectOpt.splice(removeInedx, 1)
      }
    },
    addItem (type) {  // 增加自訂標籤
      this.customeize[type]++
      this[type].push({
        name: '',
        edit: true
      })
      this.selectOpt.push({
        name: '',
        edit: true
      })
    },
    dropdownClose () {
      this.dropdownOpen = false
      this.selectedCommonTag = []
      this.currentDropdownCount = 0
      if(!this.dropdownItem) return
      this.dropdownItem.parentNode.classList.remove('show')
      this.dropdownItem.nextSibling.classList.remove('show')
    },
    submit () {
      if(this.selectOpt.length > 5 || this.selectOpt.length == 0){  //  驗證標籤總數
        return this.setToastMsg('請至少選擇一項拜訪項目')
      }

      let filterAry = [
        {type: 'visitOpt', no: 'A05'},
        {type: 'relationOpt', no: 'A01'},
        {type: 'analizeOpt', no: 'A02'},
        {type: 'recommandOpt', no: 'A03'},
        {type: 'serviceOpt', no: 'A04'},
      ]
      let filterEdit = []   // 過濾自定標籤
      let filterCommon = []   // 過濾自定標籤
      for (let option of filterAry) {
        let editCount = 90
        let commonCount = 95
        this[option.type].forEach(item => {
          if(item.edit){
            filterEdit.push({...item,code: `${option.no}${editCount}`})
            editCount++
          }
          if(item.common && !item.default){
            filterCommon.push({...item,code: `${option.no}${commonCount}`})
            commonCount++
          }
        })
      }
      //  砍掉原本的自訂與常用
      let selectString = this.selectOpt.filter(item => {
        return item.default
      })

      //  加上過濾好的自訂與常用
      selectString = [...selectString,...filterEdit,...filterCommon]

      //  將 array 轉為 string
      selectString = selectString.map(item => {
        return `${item.code}${item.name.trim()}`
      }).join(',')
      
      this.$emit('submit', this.recordInfo, this.form, selectString)
    },
    stringBytes(c, isSub, size){ //計算字元長度 (字串, 是否檢查, 檢查的長度) 
      var n=c.length,s;
      var len=0;
      for(var i=0; i <n;i++){
        s=c.charCodeAt(i);
        while( s > 0 ){
          len++;
          s = s >> 8;
          if(isSub&&len>size){
            return i;
          }
        }
      }
      return len;
    }
  },
  mounted () {
    this.init()
    this.$el.addEventListener('click', e => {
      if (!window.$(e.target).hasClass('dropdown-menu') && !$(event.target).parents().hasClass('dropdown-menu')) {
        this.dropdownClose()
      }
    })
  }
}
</script>
<style scoped>
.ele-center {
  display: flex;
  justify-content: center;
}

.row-cus {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  justify-content: center;
  text-align: center;
  margin: 10px 0px 0px 0px;
}

.btn-0 {
  padding: 7px 15px !important;
}

.h-43 {
  height: 43px !important;
}

.dropdown-menu span {
  font-weight: 500;
}

a.disabled {
  pointer-events: none;
  /* opacity: 0.8; */
  cursor: not-allowed;
}

</style>
